
<div class="bg-white p-6 rounded-md shadow-sm">
  <h2 class="text-xl font-bold text-gray-800">Customer Portal Customization</h2>
  <p class="text-gray-600 mt-1 mb-6">Customize the look and feel of your customer-facing portal.</p>

  @if (isLoading()) {
    <div class="text-center py-10 text-gray-500">
      <i class="fa-solid fa-spinner animate-spin text-2xl"></i>
    </div>
  } @else {
    <form [formGroup]="settingsForm" (ngSubmit)="onSave()" class="space-y-8">
      
      <fieldset class="space-y-4">
        <legend class="text-lg font-semibold text-gray-900 border-b pb-2 w-full mb-4">General</legend>
        <div>
          <label for="portalName" class="block text-sm font-medium text-gray-700">Portal Name</label>
          <input id="portalName" type="text" formControlName="portalName" placeholder="e.g., CHUAMKAN Member Club" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
        </div>
        <div>
          <label for="logoUrl" class="block text-sm font-medium text-gray-700">Logo URL</label>
          <input id="logoUrl" type="url" formControlName="logoUrl" placeholder="https://your-store.com/logo.png" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
        </div>
      </fieldset>

      <fieldset class="space-y-4">
        <legend class="text-lg font-semibold text-gray-900 border-b pb-2 w-full mb-4">Color Palette</legend>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- Background Color -->
          <div><label for="backgroundColor" class="block text-sm font-medium text-gray-700">Background Color</label><div class="mt-1 flex items-center gap-3"><input id="backgroundColor" type="color" formControlName="backgroundColor" class="p-0 h-10 w-14 block bg-white border border-gray-300 rounded-md cursor-pointer"><input type="text" formControlName="backgroundColor" class="block w-full border-gray-300 rounded-md shadow-sm sm:text-sm font-mono"></div></div>
          <!-- Card Color -->
          <div><label for="cardColor" class="block text-sm font-medium text-gray-700">Card Color</label><div class="mt-1 flex items-center gap-3"><input id="cardColor" type="color" formControlName="cardColor" class="p-0 h-10 w-14 block bg-white border border-gray-300 rounded-md cursor-pointer"><input type="text" formControlName="cardColor" class="block w-full border-gray-300 rounded-md shadow-sm sm:text-sm font-mono"></div></div>
          <!-- Text Color -->
          <div><label for="textColor" class="block text-sm font-medium text-gray-700">Text Color</label><div class="mt-1 flex items-center gap-3"><input id="textColor" type="color" formControlName="textColor" class="p-0 h-10 w-14 block bg-white border border-gray-300 rounded-md cursor-pointer"><input type="text" formControlName="textColor" class="block w-full border-gray-300 rounded-md shadow-sm sm:text-sm font-mono"></div></div>
          <!-- Primary Color -->
          <div><label for="primaryColor" class="block text-sm font-medium text-gray-700">Primary Color</label><div class="mt-1 flex items-center gap-3"><input id="primaryColor" type="color" formControlName="primaryColor" class="p-0 h-10 w-14 block bg-white border border-gray-300 rounded-md cursor-pointer"><input type="text" formControlName="primaryColor" class="block w-full border-gray-300 rounded-md shadow-sm sm:text-sm font-mono"></div></div>
          <!-- Accent Color -->
          <div><label for="accentColor" class="block text-sm font-medium text-gray-700">Accent Color</label><div class="mt-1 flex items-center gap-3"><input id="accentColor" type="color" formControlName="accentColor" class="p-0 h-10 w-14 block bg-white border border-gray-300 rounded-md cursor-pointer"><input type="text" formControlName="accentColor" class="block w-full border-gray-300 rounded-md shadow-sm sm:text-sm font-mono"></div></div>
        </div>
      </fieldset>
      
      @if (statusMessage(); as msg) {
        <div class="p-3 rounded-md text-sm" [class]="msg.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
            {{ msg.text }}
        </div>
      }

      <div class="flex justify-end pt-4 border-t">
        <button type="submit" [disabled]="settingsForm.invalid || isSaving()" class="bg-emerald-600 text-white px-6 py-2 rounded-md hover:bg-emerald-700 transition-colors flex items-center gap-2 disabled:bg-slate-400 disabled:cursor-not-allowed">
            @if (isSaving()) {
                <i class="fa-solid fa-spinner animate-spin"></i>
                <span>Saving...</span>
            } @else {
                <i class="fa-solid fa-save"></i>
                <span>Save Settings</span>
            }
        </button>
      </div>
    </form>
  }
</div>
